module.exports = __webpack_public_path__ + "static/img/v2-1978aacdede5ac706fd5fc40f23f8579_720w.c9f133c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/v2-1978aacdede5ac706fd5fc40f23f8579_720w.webp
// module id = FUXT
// module chunks = 0